export default {
    createSyllabus: '/syllabus/createSyllabus',
    getSyllabus: '/syllabus/getSyllabus'
    // getExams: '/newExam/getExams',
    // getExam: '/newExam/getExam',
    // deleteExam: '/newExam/deleteExam'
}
